import API from '@/API/request';

export const commonApi = {
  // 获取通知列表
  getNotificationList: (params) => API.get('/config/home/notification'),
  // 获取线索中心列表数据
  getLeadData: (params) => API.post('/lead/lead/list/condition', params)
};

export const calendarApi = {
  // 获取活动编号
  getCalendarList: (params) => API.get(`/activity/market_activity_list?startDate=${params.startDate}&endDate=${params.endDate}&currentDate=${params.currentDate}`)
};
export const notice = {
  // 获取代办列表
  getPendingApproval: (params) => API.post('/approvecenter/task_list', params)
};
